import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 0.5rem',
    minHeight: '33px',

    '& > :first-child': {
      marginRight: '-0.5rem'
    },

    '& > :nth-child(2) .icon': {
      marginBottom: '1px'
    },

    '& input': {
      width: 'auto',
      margin: '0',
      backgroundColor: 'transparent'
    },

    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',

      '& > :last-child > label': {
        marginLeft: '0'
      }
    }
  }
}))

export default useStyles
